import { ThemeConfig } from "antd/es/config-provider/context";

const themeConfig: ThemeConfig = {
    token: {
        colorPrimary: "#0152FB",
        colorLinkHover: "#0152FB",
        colorPrimaryActive: "#0152FB",
        colorText: "#1D2939",
        colorLink: "#175CD3",
    },
    components: {
        Button: {
            paddingBlock: 8,
            paddingInline: 14,
            paddingBlockSM: 4,
            paddingInlineSM: 8,
            borderRadius: 4,
            borderRadiusSM: 4,
            defaultBg: "#FFFF",
            defaultColor: "#0152FB",
            defaultBorderColor: "#0152FB",
            colorBgSolid: "#0152FB"
        },
        Tabs: {
            inkBarColor: "#12B76A",
            itemHoverColor: "#12B76A",
            itemSelectedColor: "#1D2939",
            itemActiveColor: "#12B76A",
            horizontalItemPadding: "6px 12px",
            horizontalItemGutter: 0,
            
        },
        Tag: {
            colorSuccessBg: "#D1FADF",
            colorSuccessText: "#027A48",
            colorSuccess: "#027A48",
            defaultBg: "#F2F4F7",
            colorWarningText: "#B54708",
            colorWarning: "#B54708",
            colorWarningBg:"#FEF0C7"
        },
        Input: {
            borderRadius: 4,
            colorBorder: "#E4E7EC",
            colorTextPlaceholder: "#667085"
        },
        Select: {
        },
        Table: {
            headerBg: "#EFF8FF",
            borderRadius: 8,
            fontSize: 13
        },
        Form: {
            labelFontSize: 12,
            itemMarginBottom: 0,
            verticalLabelPadding: "4px 0",
        },
        Segmented: {
            itemSelectedColor: "#0152FB",
            fontSize:12,
            trackPadding:4
        },
        Breadcrumb:{
            linkColor:"#667085",
            colorText:"#667085",
            fontSize:12
        },
    },
};
export default themeConfig;
